import {Alert, Snackbar } from "@mui/material"
import React from "react"

interface SbSnackbarProps {
    snackbarData: {
        openNotification: boolean
        severity: 'error' | 'info' | 'success' | 'warning'
        notificationMessage: string
    }
    handleCloseNotification: () => void
}

interface SbSnackbarState {

}

export class SbSnackbar extends React.Component<SbSnackbarProps, SbSnackbarState>
{
    render(){
        return (
            <Snackbar open={this.props.snackbarData.openNotification} autoHideDuration={4000} onClose={this.props.handleCloseNotification} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert
                    onClose={this.props.handleCloseNotification}
                    severity={this.props.snackbarData.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {this.props.snackbarData.notificationMessage}
                </Alert>
            </Snackbar>
        )
    }
}
